export default __webpack_public_path__ + "static/media/experiences_menu_item.8fd2f3bc.svg";